import { render, staticRenderFns } from "./selectJoin.vue?vue&type=template&id=653faef4&scoped=true"
import script from "./selectJoin.vue?vue&type=script&lang=js"
export * from "./selectJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653faef4",
  null
  
)

export default component.exports